// removed by extract-text-webpack-plugin
module.exports = {"successColor":"#59C19E","errorColor":"#EB5B5B","warningColor":"#e6a23c","primaryColor":"#6578D0","defaultColor":"#b0b0b0","waitingColor":"#9e9e16"};


//////////////////
// WEBPACK FOOTER
// ./src/style/color.scss
// module id = U7Zx
// module chunks = 27